export const GET_INVOICES_REQUEST = "GETINVOICES_REQUEST";
export const GET_INVOICES_SUCCESS = "GETINVOICES_SUCCESS";
export const GET_INVOICES_ERROR = "GETINVOICES_ERROR";

export const getInvoicesRequest = (payload) => ({
  type: GET_INVOICES_REQUEST,
  ...payload,
});

export const getInvoicesSuccess = (invoices) => ({
  type: GET_INVOICES_SUCCESS,
  invoices,
});

export const getInvoicesError = (error) => ({
  type: GET_INVOICES_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/userinvoices/actions.js